// Mock data for teachers
export const teachers = [
  { 
    id: 't001', 
    name: 'Ms. Sarah Johnson', 
    chinese: '莊老師', 
    subject: 'English', 
    email: 'sarah.j@school.edu', 
    phone: '2345-6789', 
    photo: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=150&h=150&fit=crop&crop=face',
    office: 'A101',
    department: '英文科',
    experience: '8年教學經驗'
  },
  { 
    id: 't002', 
    name: 'Mr. David Chen', 
    chinese: '陳老師', 
    subject: 'Mathematics', 
    email: 'david.c@school.edu', 
    phone: '2345-6790', 
    photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face',
    office: 'B205',
    department: '數學科',
    experience: '12年教學經驗'
  },
  { 
    id: 't003', 
    name: 'Ms. Emily Wong', 
    chinese: '黃老師', 
    subject: 'Chinese', 
    email: 'emily.w@school.edu', 
    phone: '2345-6791', 
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face',
    office: 'A203',
    department: '中文科',
    experience: '10年教學經驗'
  },
  { 
    id: 't004', 
    name: 'Mr. Michael Liu', 
    chinese: '劉老師', 
    subject: 'Science', 
    email: 'michael.l@school.edu', 
    phone: '2345-6792', 
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face',
    office: 'C301',
    department: '科學科',
    experience: '15年教學經驗'
  },
  { 
    id: 't005', 
    name: 'Ms. Lisa Zhang', 
    chinese: '張老師', 
    subject: 'History', 
    email: 'lisa.z@school.edu', 
    phone: '2345-6793', 
    photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop&crop=face',
    office: 'B108',
    department: '歷史科',
    experience: '6年教學經驗'
  },
  { 
    id: 't006', 
    name: 'Mr. Kevin Wu', 
    chinese: '吳老師', 
    subject: 'Physical Education', 
    email: 'kevin.w@school.edu', 
    phone: '2345-6794', 
    photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=face',
    office: '體育館',
    department: '體育科',
    experience: '9年教學經驗'
  },
  { 
    id: 't007', 
    name: 'Ms. Grace Lee', 
    chinese: '李老師', 
    subject: 'Art', 
    email: 'grace.l@school.edu', 
    phone: '2345-6795', 
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop&crop=face',
    office: 'D102',
    department: '美術科',
    experience: '7年教學經驗'
  },
  { 
    id: 't008', 
    name: 'Mr. Andy Tam', 
    chinese: '譚老師', 
    subject: 'Music', 
    email: 'andy.t@school.edu', 
    phone: '2345-6796', 
    photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=150&h=150&fit=crop&crop=face',
    office: '音樂室',
    department: '音樂科',
    experience: '11年教學經驗'
  },
  { 
    id: 't009', 
    name: 'Ms. Rachel Ho', 
    chinese: '何老師', 
    subject: 'Geography', 
    email: 'rachel.h@school.edu', 
    phone: '2345-6797', 
    photo: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150&h=150&fit=crop&crop=face',
    office: 'B310',
    department: '地理科',
    experience: '5年教學經驗'
  },
  { 
    id: 't010', 
    name: 'Mr. Simon Ng', 
    chinese: '吳老師', 
    subject: 'Computer Science', 
    email: 'simon.n@school.edu', 
    phone: '2345-6798', 
    photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=150&h=150&fit=crop&crop=face',
    office: 'C201',
    department: '電腦科',
    experience: '4年教學經驗'
  }
]; 